










import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { Notify, Dialog } from 'vant';
@Component({})
export default class QrCodeZhpjFeedBack extends Vue {
  // trainingScheduling: any = {};
  // classSolution: any = {};
  // waitTrainingScheduling: any = [];
  // async mounted() {
  //   let trainingScheduleId: any = this.$route.query.trainingScheduleId;
  //   let openSolutionId: any = this.$route.query.openSolutionId;
  //   if (trainingScheduleId) {
  //     {
  //       //获取当前学员所有待评教师
  //       const { data } = await api.TeacherEvaluation.getMyWaitEvaluate_GET();
  //       this.waitTrainingScheduling = data;
  //     }
  //     //获取当前培训班信息
  //     {
  //       const { data } = await api.ClassSolution.findOneById_GET({ id: openSolutionId });
  //       this.classSolution = data!;
  //     }
  //     let waitTrainingSchedulingIds = this.waitTrainingScheduling.map((item: any) => {
  //       return item.trainingSchedulingId;
  //     });
  //     //判断当前扫码评价的教师是否在待评列表中
  //     if (waitTrainingSchedulingIds.indexOf(trainingScheduleId) >= 0) {
  //       //获取当前日程
  //       const { data } = await api.TeacherEvaluation.findOneById_GET({
  //         id: trainingScheduleId,
  //       });
  //       this.trainingScheduling = data!;
  //       let trainEndTime = new Date(this.trainingScheduling.trainingEndTime);
  //       let dateTimeNow = new Date();
  //       if (trainEndTime < dateTimeNow) {
  //         let trainObject: any = {};
  //         trainObject.openClassSolutionId = this.classSolution.id;
  //         trainObject.className = this.classSolution.className;
  //         trainObject.deptId = this.classSolution.deptId;
  //         trainObject.trainType = this.classSolution.trainType;
  //         trainObject.trainingSchedulingId = this.trainingScheduling.id;
  //         trainObject.courseName = this.trainingScheduling.courseName;
  //         trainObject.teacherId = this.trainingScheduling.systemTeacherId;
  //         trainObject.teacher = this.trainingScheduling.teacher;
  //         trainObject.teacherJob = this.trainingScheduling.teacherJob;
  //         trainObject.hours = this.trainingScheduling.hours;
  //         trainObject.unitName = this.trainingScheduling.unitName;
  //         trainObject.trainingDate = this.trainingScheduling.trainingDate;
  //         trainObject.trainingTime = this.trainingScheduling.trainingTime;
  //         trainObject.trainingStartTime = this.trainingScheduling.trainingStartTime;
  //         trainObject.trainingEndTime = this.trainingScheduling.trainingEndTime;
  //         this.$router.push({
  //           name: "feedback",
  //           params: { feedbackTitle: "评价教师", teacherDetail: trainObject },
  //         });
  //       } else {
  //         this.$nextTick(() => {
  //           Dialog.confirm({
  //             message: "当前课程还未结束，不能评价！",
  //           });
  //           setTimeout(() => {
  //             Dialog.close();
  //             this.$router.push({
  //               name: "myFeedbacks",
  //               params: { feedbackStatus: "待评教师" },
  //             });
  //           }, 3000);
  //         });
  //       }
  //     } else {
  //       this.$nextTick(() => {
  //         Dialog.confirm({
  //           message: "您未参加当前课程或者已经评价过，故不能评价！",
  //         });
  //         setTimeout(() => {
  //           Dialog.close();
  //           this.$router.push({
  //             name: "myFeedbacks",
  //             params: { feedbackStatus: "待评教师" },
  //           });
  //         }, 3000);
  //       });
  //     }
  //   }
  // }
}
